import { useCallback } from 'react';
import { useFeatures } from '../providers/features-provider';
import { useUser } from '../providers/user-provider';
import { openPlanPrompt } from '../util/plan-required';

// A plan feature (an inclusion key - 'userAcl', 'xeroIntegration',
// 'stripeIntegration', 'advancedFeatures'): whether the company has it (its
// plan includes it, or it turned the add-on on - features-controller.js
// "plan.<key>"), and the upgrade / add-on prompt for when it doesn't. Pages
// without the feature stay viewable but read-only - their create / update /
// delete actions call prompt() instead.
export const usePlanFeature = (feature: string) => {
    const { isLoaded, isVisibleInNav } = useFeatures();
    const { user } = useUser();
    // Until features load, treat it as available - no flash of a locked page.
    const has = !isLoaded || isVisibleInNav(`plan.${feature}`);
    const prompt = useCallback(() => { openPlanPrompt(user?.entityId, feature); }, [user?.entityId, feature]);
    return { has, prompt };
};
